export const CLIENT_DEFAULT_NAME = 'Пользователь';
export const CLIENT_EMPLOYER_DEFAULT_NAME = 'Наниматель';
